/** Small pure helpers of the Chats page (names, times, links, GIF answers). */
import { asList, asObj, num, str, unwrap } from '../data'
import type { ChatGif } from './model'

export const initialsOf = (name: string) =>
  name
    .replace(/^@/, '')
    .split(/\s+/)
    .map((w) => w[0] ?? '')
    .join('')
    .slice(0, 2)
    .toUpperCase()

/** "14:05" today, "Yesterday", a weekday this week, else a date. */
export function chatTime(ms: number, now: number, locale: string, yesterday: string): string {
  if (!ms) return ''
  const d = new Date(ms)
  const today = new Date(now)
  if (d.toDateString() === today.toDateString()) return d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
  const y = new Date(now)
  y.setDate(today.getDate() - 1)
  if (d.toDateString() === y.toDateString()) return yesterday
  if (now - ms < 6 * 86_400_000) return d.toLocaleDateString(locale, { weekday: 'short' })
  return d.toLocaleDateString(locale, { day: 'numeric', month: 'short', ...(d.getFullYear() !== today.getFullYear() ? { year: '2-digit' } : {}) })
}

export const fanslyChatUrl = (groupId: string) => `https://fansly.com/messages/${encodeURIComponent(groupId)}`
export const fanslyProfileUrl = (username: string) => `https://fansly.com/${encodeURIComponent(username)}`

/** Fansly's GIF provider posts (gif-provider/featured|search) as pickable GIFs. */
export function gifsOf(payload: unknown): ChatGif[] {
  const u = unwrap(payload)
  const list = Array.isArray(u) ? asList(u) : asList(asObj(u).results ?? asObj(u).posts ?? asObj(u).data)
  return list
    .map((p) => ({
      url: str(p.itemurl) || str(p.url),
      src: str(p.tinyGifUrl) || str(p.gifUrl) || str(p.url),
      width: num(p.width),
      height: num(p.height),
      title: str(p.title),
    }))
    .filter((g) => /^https?:/i.test(g.url) && /^(https?:|data:image\/)/i.test(g.src))
}

export function gifCategoriesOf(payload: unknown): string[] {
  const u = unwrap(payload)
  const list = Array.isArray(u) ? asList(u) : asList(asObj(u).categories ?? asObj(u).tags)
  return [...new Set(list.map((c) => str(c.searchterm) || str(c.name)).filter(Boolean))].slice(0, 24)
}

